import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from "react";

function Abb() {
  useEffect(() => {
    AOS.init({
      duration: 2000,
      once: true,
    });
  }, []);
  return (
    <>
      <div className="container-fluid page-header py-5 mb-5 animate__animated animate__fadeIn">
        <div className="container py-5">
          <h1 className="display-3 text-white animate__animated animate__slideInRight">
            ABB
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb animate__animated animate__slideInRight mb-0">
              <li className="breadcrumb-item text-white">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item text-white">
                <Link to="/">Products</Link>
              </li>
              <li
                className="breadcrumb-item active text-light "
                aria-current="page"
              >
                ABB
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Introduction Section */}
      <section className="intro-section py-5 bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center" data-aos="zoom-in">
              <h2 className="text-danger text-gradient-primary mb-4">
                ABB Industrial Automation Solutions
              </h2>
              <p className="lead">
                ABB provides cutting-edge automation solutions across industries
                with its advanced Programmable Logic Controllers (PLC),
                Human-Machine Interfaces (HMI), Variable Speed Drives (VSDs),
                Supervisory Control and Data Acquisition (SCADA), and
                Distributed Control Systems (DCS).
              </p>
              <div className="row mt-4">
                <div
                  className="col-md-4 mb-3"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body">
                      <i
                        className="fas fa-microchip text-danger mb-3"
                        style={{ fontSize: "2rem" }}
                      ></i>
                      <h5>Enhanced Efficiency</h5>
                      <p>
                        Optimize your industrial processes with precision
                        control
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-4 mb-3"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body">
                      <i
                        className="fas fa-shield-alt text-danger mb-3"
                        style={{ fontSize: "2rem" }}
                      ></i>
                      <h5>Reliable Performance</h5>
                      <p>Industry-proven solutions with maximum uptime</p>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-4 mb-3"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body">
                      <i
                        className="fas fa-expand-arrows-alt text-danger mb-3"
                        style={{ fontSize: "2rem" }}
                      ></i>
                      <h5>Scalable Solutions</h5>
                      <p>Grow your automation system as your needs evolve</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Sections */}
      <section className="product-section py-5">
        <div className="container">
          {/* AC500 PLC */}
          <div className="row align-items-center mb-5" data-aos="fade-up">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img
                src={require("../assets/img/products/Abb/AC500 Series PLC ABBs AC50.png")}
                alt="AC500 PLC Series"
                className="img-fluid rounded shadow"
              />
            </div>
            <div className="col-lg-6">
              <div className="ps-lg-4">
                <span className="badge bg-danger mb-2">
                  Programmable Logic Controller
                </span>
                <h3 className="fw-bold mb-3">AC500 Series PLC</h3>
                <p className="mb-4">
                  ABB's AC500 PLC series is engineered for high performance,
                  offering flexible and scalable automation solutions. Designed
                  for seamless integration, these PLCs provide secure cloud
                  connectivity and efficient process control.
                </p>
                <h5 className="text-danger mb-3">Key Applications</h5>
                <ul className="list-unstyled">
                  <li className="mb-2">
                    <i className="fas fa-check-circle text-danger me-2"></i>
                    Factory and machine automation
                  </li>
                  <li className="mb-2">
                    <i className="fas fa-check-circle text-danger me-2"></i>
                    Process control in food & beverage industries
                  </li>
                  <li className="mb-2">
                    <i className="fas fa-check-circle text-danger me-2"></i>
                    Water and wastewater management
                  </li>
                  <li className="mb-2">
                    <i className="fas fa-check-circle text-danger me-2"></i>
                    Power distribution systems
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* CP600 HMI */}
          <div
            className="row align-items-center mb-5 p-4 rounded"
            data-aos="fade-up"
            style={{ backgroundColor: "E9ECEF" }}
          >
            <div className="col-lg-6 order-lg-2 mb-4 mb-lg-0">
              <img
                src={require("../assets/img/products/Abb/last.png")}
                alt="CP600 HMI Series"
                className="img-fluid rounded shadow"
              />
            </div>
            <div className="col-lg-6 order-lg-1">
              <div className="pe-lg-4">
                <span className="badge bg-danger mb-2">
                  Human-Machine Interface
                </span>
                <h3 className="fw-bold mb-3">CP600 Series HMI</h3>
                <p className="mb-4">
                  ABB's CP600 HMI series enhances industrial automation with
                  high-resolution displays and multi-touch functionality. These
                  HMIs provide intuitive control, real-time monitoring, and
                  seamless connectivity with ABB PLCs.
                </p>
                <h5 className="text-danger mb-3">Key Applications</h5>
                <ul className="list-unstyled">
                  <li className="mb-2">
                    <i className="fas fa-check-circle text-danger me-2"></i>
                    Machine control in packaging industries
                  </li>
                  <li className="mb-2">
                    <i className="fas fa-check-circle text-danger me-2"></i>
                    SCADA and factory automation
                  </li>
                  <li className="mb-2">
                    <i className="fas fa-check-circle text-danger me-2"></i>
                    Real-time plant monitoring
                  </li>
                  <li className="mb-2">
                    <i className="fas fa-check-circle text-danger me-2"></i>
                    Energy management systems
                  </li>
                </ul>
                <button className="btn btn-outline-light mt-3">
                  Learn More
                </button>
              </div>
            </div>
          </div>

          {/* Variable Speed Drives */}
          <div className="row align-items-center mb-5" data-aos="fade-up">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img
                src={require("../assets/img/products/Abb/Variable Speed Drives (VSDs) ABBs variable speed drives.png")}
                alt="ABB Variable Speed Drives"
                className="img-fluid rounded shadow"
              />
            </div>
            <div className="col-lg-6">
              <div className="ps-lg-4">
                <span className="badge bg-danger mb-2">Drive Technology</span>
                <h3 className="fw-bold mb-3">Variable Speed Drives (VSDs)</h3>
                <p className="mb-4">
                  ABB's variable speed drives optimize energy consumption and
                  enhance motor efficiency by providing precise speed and torque
                  control. They are designed to improve performance in various
                  industrial applications.
                </p>
                <h5 className="text-danger mb-3">Key Applications</h5>
                <div className="row">
                  <div className="col-md-6">
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <i className="fas fa-check-circle text-danger me-2"></i>
                        HVAC systems
                      </li>
                      <li className="mb-2">
                        <i className="fas fa-check-circle text-danger me-2"></i>
                        Conveyor systems
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <i className="fas fa-check-circle text-danger me-2"></i>
                        Pump and fan applications
                      </li>
                      <li className="mb-2">
                        <i className="fas fa-check-circle text-danger me-2"></i>
                        Automotive industry
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* SCADA Systems */}
          <div className="row align-items-center mb-5" data-aos="fade-up">
            <div className="col-lg-6 order-lg-2 mb-4 mb-lg-0">
              <img
                src={require("../assets/img/products/Abb/ABB Ability SCADA Systems ABB SCADA systems provide-1.png")}
                alt="ABB Ability SCADA"
                className="img-fluid rounded shadow"
              />
            </div>
            <div className="col-lg-6 order-lg-1">
              <div className="pe-lg-4">
                <span className="badge bg-danger mb-2">
                  Monitoring & Control
                </span>
                <h3 className="fw-bold mb-3">ABB Ability™ SCADA Systems</h3>
                <p className="mb-4">
                  ABB's SCADA systems provide real-time data monitoring,
                  control, and analytics for industrial automation. These
                  solutions help operators optimize production processes,
                  increase efficiency, and ensure system reliability.
                </p>
                <h5 className="text-danger mb-3">Key Applications</h5>
                <div className="row">
                  <div className="col-md-6">
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <i className="fas fa-check-circle text-danger me-2"></i>
                        Remote plant monitoring
                      </li>
                      <li className="mb-2">
                        <i className="fas fa-check-circle text-danger me-2"></i>
                        Power grid management
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <i className="fas fa-check-circle text-danger me-2"></i>
                        Water treatment systems
                      </li>
                      <li className="mb-2">
                        <i className="fas fa-check-circle text-danger me-2"></i>
                        Oil and gas pipelines
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* DCS Highlight Section */}
      <section
        className="dcs-section bg-danger text-white py-5"
        data-aos="fade-up"
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h2 className="fw-bold mb-4">ABB Ability™ System 800xA</h2>
              <h4 className="mb-4">Distributed Control Systems (DCS)</h4>
              <p className="lead mb-5">
                ABB's Ability™ System 800xA provides advanced process
                automation, integrating control, safety, and asset management.
                It ensures reliable and efficient operation of complex
                industrial processes.
              </p>
              <div className="row">
                <div className="col-md-3 mb-4">
                  <div className="card bg-dark text-white border-0 h-100">
                    <div className="card-body">
                      <i
                        className="fas fa-oil-can mb-3"
                        style={{ fontSize: "2rem" }}
                      ></i>
                      <h5>Oil & Gas</h5>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 mb-4">
                  <div className="card bg-dark text-white border-0 h-100">
                    <div className="card-body">
                      <i
                        className="fas fa-flask mb-3"
                        style={{ fontSize: "2rem" }}
                      ></i>
                      <h5>Chemical</h5>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 mb-4">
                  <div className="card bg-dark text-white border-0 h-100">
                    <div className="card-body">
                      <i
                        className="fas fa-bolt mb-3"
                        style={{ fontSize: "2rem" }}
                      ></i>
                      <h5>Power Generation</h5>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 mb-4">
                  <div className="card bg-dark text-white border-0 h-100">
                    <div className="card-body">
                      <i
                        className="fas fa-mountain mb-3"
                        style={{ fontSize: "2rem" }}
                      ></i>
                      <h5>Mining</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Abb;
